// Required to anchor the (search) route group at /byggeradar/. The parent
// route.tsx redirects here (with a restored search) when the path is hit,
// so this component never actually renders. If this wasn't here, it would
//  result in a 404 on the ByggeRadar route, when no proposal is selected.
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(restricted)/byggeradar/_access/(landing)/",
)({
  component: () => null,
});
